"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKProvider = void 0;
var api_client_1 = require("./api-client");
var override_console_methods_1 = require("./browser-integration/override-console-methods");
var print_to_console_1 = require("./browser-integration/print-to-console");
var register_browser_events_handler_1 = require("./browser-integration/register-browser-events-handler");
var register_error_handler_1 = require("./browser-integration/register-error-handler");
var register_ui_events_handler_1 = require("./browser-integration/register-ui-events-handler");
var call_info_factory_1 = require("./call-info-factory");
var channel_1 = require("./channel");
var connection_1 = require("./connection");
var current_session_1 = require("./current-session");
var database_1 = require("./data/database");
var device_keys_table_1 = require("./data/device-keys.table");
var in_memory_storage_1 = require("./data/in-memory.storage");
var issues_table_1 = require("./data/issues.table");
var logs_table_1 = require("./data/logs.table");
var sessions_table_1 = require("./data/sessions.table");
var device_1 = require("./device");
var http_client_1 = require("./http-client");
var log_factory_1 = require("./log-factory");
var logger_1 = require("./logger");
var reset_storage_1 = require("./reset-storage");
var sdk_options_1 = require("./sdk-options");
var session_factory_1 = require("./session-factory");
var storage_guard_1 = require("./storage-guard");
var storage_processor_1 = require("./storage-processor");
var storage_writer_1 = require("./storage-writer");
var storage_writer_handler_1 = require("./storage-writer.handler");
var storage_writer_hub_1 = require("./storage-writer.hub");
var user_feedback_1 = require("./user-feedback");
var utils_1 = require("./utils");
var uuid_factory_1 = require("./uuid-factory");
var storage_writer_worker_1 = __importDefault(require("./storage-writer.worker"));
var cache = new Map();
var Cached = utils_1.CacheDecoratorFactory(cache);
var SDKProvider = (function () {
    function SDKProvider(featureDetection, sdkUserAgent, version, window) {
        this.featureDetection = featureDetection;
        this.sdkUserAgent = sdkUserAgent;
        this.version = version;
        this.window = window;
        this.uuidFactory = new uuid_factory_1.UUIDFactory();
        this.console = window.console;
    }
    SDKProvider.prototype.setOptions = function (options) {
        this.options = options;
    };
    SDKProvider.prototype.getApiClient = function () {
        var httpClient = new http_client_1.HttpClient(this.options.apiURL, this.options.appKey, this.sdkUserAgent);
        return new api_client_1.ApiClient(this.options.appKey, httpClient);
    };
    SDKProvider.prototype.getChannel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, this.featureDetection.isMultiTabSupported()];
                    case 1:
                        if (!_d.sent()) return [3, 3];
                        _a = channel_1.Channel.bind;
                        _b = [void 0, channel_1.createBroadcastChannel(),
                            this.getLogger('Channel')];
                        return [4, this.getCurrentSession()];
                    case 2: return [2, new (_a.apply(channel_1.Channel, _b.concat([_d.sent()])))()];
                    case 3:
                        _c = channel_1.MonoChannel.bind;
                        return [4, this.getCurrentSession()];
                    case 4: return [2, new (_c.apply(channel_1.MonoChannel, [void 0, _d.sent()]))()];
                }
            });
        });
    };
    SDKProvider.prototype.getConnection = function () {
        return new connection_1.Connection(this.window);
    };
    SDKProvider.prototype.getCurrentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = current_session_1.CurrentSession.bind;
                        _b = [void 0, this.getDevice(),
                            this.getLogger('CurrentSession'),
                            this.getSessionStorage()];
                        return [4, this.getSessionsTable()];
                    case 1: return [2, new (_a.apply(current_session_1.CurrentSession, _b.concat([_c.sent(), this.uuidFactory])))()];
                }
            });
        });
    };
    SDKProvider.prototype.getDatabase = function () {
        return new database_1.Database();
    };
    SDKProvider.prototype.getDevice = function () {
        return new device_1.Device(this.getLocalStorage(), this.version, this.uuidFactory, this.window);
    };
    SDKProvider.prototype.getDeviceKeysTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.featureDetection.isIndexedDBSupported()];
                    case 1:
                        if (_a.sent()) {
                            return [2, new device_keys_table_1.IDBDeviceKeysTable(this.getDatabase().devicekeys)];
                        }
                        else {
                            return [2, new device_keys_table_1.InMemoryDeviceKeysTable()];
                        }
                        return [2];
                }
            });
        });
    };
    SDKProvider.prototype.getIssuesTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.featureDetection.isIndexedDBSupported()];
                    case 1:
                        if (_a.sent()) {
                            return [2, new issues_table_1.IDBIssuesTable(this.getDatabase().issues)];
                        }
                        else {
                            return [2, new issues_table_1.InMemoryIssuesTable()];
                        }
                        return [2];
                }
            });
        });
    };
    SDKProvider.prototype.getLogger = function (tag) {
        if (this.options.debug) {
            return new logger_1.ConsoleLogger(this.console, tag);
        }
        else {
            return new logger_1.NoopLogger();
        }
    };
    SDKProvider.prototype.getLogsTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.featureDetection.isIndexedDBSupported()];
                    case 1:
                        if (_a.sent()) {
                            return [2, new logs_table_1.IDBLogsTable(this.getDatabase().logs, new log_factory_1.LogFactory())];
                        }
                        else {
                            return [2, new logs_table_1.InMemoryLogsTable()];
                        }
                        return [2];
                }
            });
        });
    };
    SDKProvider.prototype.getOverrideConsoleMethods = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = override_console_methods_1.OverrideConsoleMethods.bind;
                        return [4, this.getStorageWriterHub()];
                    case 1: return [2, new (_a.apply(override_console_methods_1.OverrideConsoleMethods, [void 0, _b.sent(), this.window]))()];
                }
            });
        });
    };
    SDKProvider.prototype.getPrintToConsole = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new print_to_console_1.PrintToConsole(this.console)];
            });
        });
    };
    SDKProvider.prototype.getRegisterBrowserEventsHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = register_browser_events_handler_1.RegisterBrowserEventsHandler.bind;
                        return [4, this.getStorageWriterHub()];
                    case 1: return [2, new (_a.apply(register_browser_events_handler_1.RegisterBrowserEventsHandler, [void 0, _b.sent(), this.window]))()];
                }
            });
        });
    };
    SDKProvider.prototype.getRegisterErrorHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new register_error_handler_1.RegisterErrorHandler(this.window)];
            });
        });
    };
    SDKProvider.prototype.getRegisterUIEventsHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = register_ui_events_handler_1.RegisterUIEventsHandler.bind;
                        return [4, this.getStorageWriterHub()];
                    case 1: return [2, new (_a.apply(register_ui_events_handler_1.RegisterUIEventsHandler, [void 0, _b.sent(), this.window]))()];
                }
            });
        });
    };
    SDKProvider.prototype.getResetStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = reset_storage_1.ResetStorage.bind;
                        _b = [void 0, this.featureDetection];
                        return [4, this.getCurrentSession()];
                    case 1: return [2, new (_a.apply(reset_storage_1.ResetStorage, _b.concat([_c.sent(), this.getDatabase(),
                            this.getLocalStorage(),
                            this.getSessionStorage()])))()];
                }
            });
        });
    };
    SDKProvider.prototype.getSDKOptions = function () {
        return new sdk_options_1.SDKOptions();
    };
    SDKProvider.prototype.getStorageGuard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = storage_guard_1.StorageGuard.bind;
                        _b = [void 0, this.getApiClient()];
                        return [4, this.getDevice()];
                    case 1: return [2, new (_a.apply(storage_guard_1.StorageGuard, _b.concat([_c.sent(), this.options])))()];
                }
            });
        });
    };
    SDKProvider.prototype.getStorageProcessor = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionFactory, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sessionFactory = new session_factory_1.SessionFactory(this.getDevice(), this.version, this.window);
                        _a = storage_processor_1.StorageProcessor.bind;
                        _b = [void 0, this.getApiClient()];
                        return [4, this.getChannel()];
                    case 1:
                        _b = _b.concat([_c.sent(), this.getConnection(),
                            this.getLogger('StorageProcessor'),
                            this.getDevice()]);
                        return [4, this.getDeviceKeysTable()];
                    case 2:
                        _b = _b.concat([_c.sent()]);
                        return [4, this.getIssuesTable()];
                    case 3:
                        _b = _b.concat([_c.sent()]);
                        return [4, this.getLogsTable()];
                    case 4:
                        _b = _b.concat([_c.sent(), this.options,
                            sessionFactory]);
                        return [4, this.getSessionsTable()];
                    case 5:
                        _b = _b.concat([_c.sent()]);
                        return [4, this.getStorageGuard()];
                    case 6: return [2, new (_a.apply(storage_processor_1.StorageProcessor, _b.concat([_c.sent()])))()];
                }
            });
        });
    };
    SDKProvider.prototype.getStorageWriterHub = function () {
        return __awaiter(this, void 0, void 0, function () {
            var useWorker, handler, _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4, this.featureDetection.isIndexedDBSupported()];
                    case 1:
                        useWorker = (_f.sent()) && this.featureDetection.isWorkerSupported();
                        if (!useWorker) return [3, 2];
                        handler = new storage_writer_worker_1.default();
                        return [3, 6];
                    case 2:
                        _a = storage_writer_handler_1.MainThreadStorageWriterHandler.bind;
                        _b = storage_writer_1.StorageWriter.bind;
                        return [4, this.getDeviceKeysTable()];
                    case 3:
                        _c = [void 0, _f.sent()];
                        return [4, this.getIssuesTable()];
                    case 4:
                        _c = _c.concat([_f.sent(), new log_factory_1.LogFactory()]);
                        return [4, this.getLogsTable()];
                    case 5:
                        handler = new (_a.apply(storage_writer_handler_1.MainThreadStorageWriterHandler, [void 0, new (_b.apply(storage_writer_1.StorageWriter, _c.concat([_f.sent()])))()]))();
                        _f.label = 6;
                    case 6:
                        _d = storage_writer_hub_1.StorageWriterHub.bind;
                        _e = [void 0, new call_info_factory_1.CallInfoFactory()];
                        return [4, this.getChannel()];
                    case 7:
                        _e = _e.concat([_f.sent(), this.getDevice(),
                            handler,
                            this.options]);
                        return [4, this.getCurrentSession()];
                    case 8:
                        _e = _e.concat([_f.sent()]);
                        return [4, this.getStorageGuard()];
                    case 9: return [2, new (_d.apply(storage_writer_hub_1.StorageWriterHub, _e.concat([_f.sent(), this.uuidFactory,
                            this.window])))()];
                }
            });
        });
    };
    SDKProvider.prototype.getLocalStorage = function () {
        if (this.featureDetection.isLocalStorageSupported()) {
            return this.window.localStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    };
    SDKProvider.prototype.getSessionStorage = function () {
        if (this.featureDetection.isSessionStorageSupported()) {
            return this.window.sessionStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    };
    SDKProvider.prototype.getSessionsTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.featureDetection.isIndexedDBSupported()];
                    case 1:
                        if (_a.sent()) {
                            return [2, new sessions_table_1.IDBSessionsTable(this.getDatabase().sessions)];
                        }
                        else {
                            return [2, new sessions_table_1.InMemorySessionsTable()];
                        }
                        return [2];
                }
            });
        });
    };
    SDKProvider.prototype.getUserFeedback = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = user_feedback_1.UserFeedback.bind;
                        return [4, this.getStorageWriterHub()];
                    case 1: return [2, new (_a.apply(user_feedback_1.UserFeedback, [void 0, _b.sent()]))()];
                }
            });
        });
    };
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", api_client_1.ApiClient)
    ], SDKProvider.prototype, "getApiClient", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getChannel", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", connection_1.Connection)
    ], SDKProvider.prototype, "getConnection", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getCurrentSession", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", database_1.Database)
    ], SDKProvider.prototype, "getDatabase", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Object)
    ], SDKProvider.prototype, "getDevice", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getDeviceKeysTable", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getIssuesTable", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getLogsTable", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getOverrideConsoleMethods", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getPrintToConsole", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getRegisterBrowserEventsHandler", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getRegisterErrorHandler", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getRegisterUIEventsHandler", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getResetStorage", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", sdk_options_1.SDKOptions)
    ], SDKProvider.prototype, "getSDKOptions", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getStorageGuard", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getStorageProcessor", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getStorageWriterHub", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Storage)
    ], SDKProvider.prototype, "getLocalStorage", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Storage)
    ], SDKProvider.prototype, "getSessionStorage", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getSessionsTable", null);
    __decorate([
        Cached(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SDKProvider.prototype, "getUserFeedback", null);
    return SDKProvider;
}());
exports.SDKProvider = SDKProvider;
